<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <ToolbarTitles :title="title" />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard" class="container">
        <CardsView
          :items="businessUnits"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-if="!showCard" class="container">
        <TableWithSearch
          :items="businessUnits"
          :headers="headersBusinessUnits"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="open"
        :max-width="maxWidth[0]"
        hide-overlay
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
        />
      </v-dialog>
      <my-dialog
        @closeEditDialog="closeEditDialog"
        :dialog="showModelRelation"
      ></my-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        :maxWidth="'400'"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import date from "@/store/common/date";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import MyDialog from "./relations/mainRelations.vue";
import businessUnits from "../../../store/unidadesDeNegocios/businessUnits";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
    MyDialog,
  },
  data() {
    return {
      showCard: true,
      title: this.$tc("businessUnits.businessUnits"),
      titleDelete: this.$tc("businessUnits.toBusinessUnit"),
      isLoading: true,
      maxWidth: ["550px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      itemId: null,
      showModelRelation: false,
      dataInputs: [
        {
          name: "name",
          label: "Nombre",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
          ],
        },
      ],
      headers: {
        businessUnits: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Nombre dale",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        operators: [
          {
            text: "Nombre operador",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Desde",
            value: "dateStart",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Hasta",
            value: "dateEnd",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Por defecto",
            value: "isDefaultTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        tables: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Código de Acceso a Tablas",
            value: "cat",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Por defecto",
            value: "isDefaultTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
      },
    };
  },
  async mounted() {
    // Fetch business units and handle potential errors
    try {
      await businessUnits.dispatch("getBusinessUnits");
    } catch (error) {
      console.error("Error fetching business units:", error);
    } finally {
      // Set loading state to false regardless of the outcome
      this.isLoading = false;
    }

    // Clear columns in the config table state
    configTable.commit("setColums", []);
    const nameTable = this.title;

    // Fetch columns table name and handle potential errors
    try {
      await configTable.dispatch("getColumsTableName", nameTable);
      if (
        configTable.state.colums.length === 0 ||
        Object.values(this.allColums).reduce(
          (sum, array) => sum + array.length,
          0
        ) !==
          Object.values(this.headers).reduce(
            (sum, array) => sum + array.length,
            0
          )
      ) {
        this.saveConfigColumns();
      }
    } catch (error) {
      console.error("Error fetching columns table name:", error);
    }
  },
  computed: {
    headersBusinessUnits() {
      return configTable.state.colums.businessUnits;
    },
    allColums() {
      return configTable.state.colums;
    },
    businessUnits() {
      return businessUnits.state.businessUnits;
    },

    padding() {
      return businessUnits.state.paddingNav;
    },
    mode: {
      get() {
        return businessUnits.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return businessUnits.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return businessUnits.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      await businessUnits.dispatch("getBusinessUnits");
    },
    updateHeaders(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        businessUnits: headers,
      };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = this.allColums;

      if (
        columnsToSave === undefined ||
        Object.values(this.allColums).reduce(
          (sum, array) => sum + array.length,
          0
        ) !==
          Object.values(this.headers).reduce(
            (sum, array) => sum + array.length,
            0
          ) ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    add(form) {
      let payload = {
        nombre: form.name,
      };
      businessUnits.commit("setNew", payload);
      businessUnits
        .dispatch("add")
        .then(() => {
          this.showAlert(this.$tc("businessUnits.addSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(this.$tc("businessUnits.addSuccess"), "#ff8d58");
        });
      this.reset(false);
    },
    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.add(items);
          break;
        case "edit":
          this.edit(items);
          break;
        default:
          break;
      }
    },
    cardView(value) {
      this.showCard = value;
    },
    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      businessUnits.commit("setOpen", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");

      return `${day}-${month}-${year}`;
    },
    async setEdit(item) {
      await businessUnits.dispatch("getBusinessUnitsId", this.itemId);
      businessUnits.commit("setUnitId", this.itemId);
    },
    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          businessUnits.commit(
            "setMode",
            this.$tc("businessUnits.addBusinessUnit")
          );
          businessUnits.commit("setOpen", true);
          break;
        case "edit":
          this.itemId = item.id;
          businessUnits.commit(
            "setMode",
            this.$tc("businessUnits.editBusinessUnit")
          );

          await this.setEdit(item);
          this.openEditDialog();

          break;
        case "delete":
          businessUnits.commit("setOpenDelete", true);
          this.itemToDelete = item.id;
          break;

        default:
          break;
      }
    },

    deleteItem() {
      businessUnits.commit("setItemDelete", this.itemToDelete);
      businessUnits
        .dispatch("delete")
        .then(() => {
          this.openDelete = false;
          businessUnits.commit("setOpenDelete", false);
          this.showAlert(this.$tc("businessUnits.deleteSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationError"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      businessUnits.commit("setOpenDelete", false);
    },
    openEditDialog() {
      this.$forceUpdate();
      this.showModelRelation = true;
    },

    closeEditDialog() {
      this.$forceUpdate();
      this.showModelRelation = false;
    },
  },
};
</script>
<style>
.v-toolbar__content {
  margin: 0;
}
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
